export default __webpack_public_path__ + "static/media/Mask of Conajohara.384b1a63.jpg";